import { Component } from '@angular/core';
import { version } from '@env/version';

import { IBuildVersion } from './build-version.models';

@Component({
	selector: 'app-build-version',
	templateUrl: './build-version.component.html',
	styleUrls: ['./build-version.component.scss']
})
export class BuildVersionComponent {
	public buildVersion: IBuildVersion = version;

	constructor() {}
}
